import { lazy } from 'react';

export const TradingJournalAgentLazy = lazy(
    () => import('./trading-journal-agent-page'),
);
